import request from '@/utils/request'
// 获取卡操作记录列表
export function cardOperationPage(data) {
    return request({
      url: '/card/operation/page',
      method: 'post',
      data: data
    })
}
//获取操作记录条数（处理中）
export function cardOperationCount(data) {
  return request({
    url: '/card/operation/count',
    method: 'get',
    params: data
  })
}